import { createContext } from 'react'

export interface FeatureFlags {
  featureFlags: {
    name: string
    value: string
    retirementDate: Date
  }[]
}

export interface FeatureFlagInterface {
  featureFlagList: FeatureFlags | undefined
  GetFeatureFlagByName: (name: string) => string
}

const stub = (): never => {
  throw new Error('You forgot to wrap your component in <FeatureFlagProvider>.')
}

const initialContext = {
  featureFlagList: undefined,
  GetFeatureFlagByName: stub
}

export const FeatureFlagsContext = createContext<FeatureFlagInterface>(initialContext)

